import React, { useState } from 'react';
import DoctorForm from '../Doctor/DoctorForm';
import DoctorProfile from './DoctorProfile';
import useAuth from 'app/hooks/useAuth';
import AdminProfile from './AdminProfile';
import NotFound from '../sessions/NotFound';
import { getSelectedDoctorDetails } from 'app/api-ws/doctor-ws.js';
import { Alert, Snackbar } from '@mui/material';
import { getSelectedAdminDetails } from 'app/api-ws/admin-ws.js';
import { getAllSpecialistsDetails } from 'app/api-ws/specialists-ws';
import SpecialistProfile from './SpecialistProfile';
const ProfilePage = () => {
  const { user } = useAuth();
  const [userDetails, setUserDetails] = useState(user);
  const [openDialog, setOpenDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackBarType, setSnackBarType] = useState('success');
  const handleCloseDialog = () => {
    getUserDetails();
    setOpenDialog(false);
  };
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  function showSnackBar() {
    setOpen(true);
  }
  function handleClose(_, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }
  const getUserDetails = () => {
    if (user?.role === 'DOCTOR') {
      getSelectedDoctorDetails(user?._id)
        .then((res) => {
          setUserDetails(res.data.doctorData);
        })
        .catch((err) => {
          console.log(err);
          setSnackBarMessage('Error in retrieving Profile Details');
          setSnackBarType('error');
          showSnackBar();
        });
    } else if (user?.role === 'ADMIN') {
      getSelectedAdminDetails(user?._id)
        .then((res) => {
          console.log(res);
          setUserDetails(res.data.Data);
        })
        .catch((err) => {
          console.log(err);
          setSnackBarMessage('Error in retrieving Profile Details');
          setSnackBarType('error');
          showSnackBar();
        });
    } else if (user?.role === 'SPECIALIST') {
      getAllSpecialistsDetails(user?.AuthToken)
        .then((res) => {
          console.log(res);
          setUserDetails(res.data.specialistData);
        })
        .catch((err) => {
          console.log(err);
          setSnackBarMessage('Error in retrieving Profile Details');
          setSnackBarType('error');
          showSnackBar();
        });
    }
  };

  if (user?.role === 'ADMIN') {
    return (
      <div>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            severity={snackBarType}
            sx={{ width: '100%' }}
            variant="filled"
          >
            {snackBarMessage}
          </Alert>
        </Snackbar>
        <AdminProfile
          userDetails={userDetails}
          openDialog={openDialog}
          handleDialogClose={handleCloseDialog}
          handleDialogOpen={handleOpenDialog}
        />
      </div>
    );
  } else if (user?.role === 'DOCTOR') {
    return (
      <DoctorProfile
        userDetails={userDetails}
        doctorId={user?._id}
        openDialog={openDialog}
        handleDialogClose={handleCloseDialog}
        handleDialogOpen={handleOpenDialog}
      />
    );
  } else if (user?.role === 'SPECIALIST') {
    return (
      <SpecialistProfile
        getUserDetails={getUserDetails}
        userDetails={userDetails}
        specialistId={user?._id}
        openDialog={openDialog}
        handleDialogClose={handleCloseDialog}
        handleDialogOpen={handleOpenDialog}
      />
    );
  } else {
    return <NotFound />;
  }
};

export default ProfilePage;
